export default "__VITE_ASSET__C8oF$VCR__"